module.exports = __webpack_public_path__ + "img/smart-fit-logo.bbb4a159.png";